import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
//import { RouterModule }  from '@angular/router';

/*
 * Components
 */
import { LoginComponent } from './login.component';

/*
* Routning
*/
//import { CoreRoutingModule }     from './core-routing.module';


@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  providers: []
})

export class CoreModule { }



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/core/core.module.ts